import { getCookie } from '../utils/cookie';

import request, { apiURL } from '../utils/api';
class PriorityLevelService {
  getAll(organizationId: string) {
    const options = {
      headers: {
        Authorization: getCookie('session_id'),
        'Content-Type': 'application/json',
      },
    };
    return request(`${apiURL}/${organizationId}/priorityLevels`, options);
  }
}

export default PriorityLevelService;
